<div class="content-section" [ngClass]="{ 'expand' : layoutService.expandedMenu }">
    <div class="d-flex title-div">
        <div class="w-50">
            <div class="back-section">
                <button class="back-button" (click)="navigateBackTo()">
                    <img class="back-image" src="assets/icons/chevronLeftOutlined.svg" />
                    <span class="back-text">{{ 'CHECK.BACK' | translate }}</span>
                </button>
            </div>
            <div class="col p-0 d-flex justify-content-between align-items-center">
                <div class="col-11 p-0">
                    <h2 class="background_title">{{ 'CHECK.HYGIENE_CHECK_PREVIEW' | translate }}</h2>
                </div>
            </div>
        </div>
        <div>
            <a class="btn-edit-icon" (click)="navigateToEdit()">
                <img src="assets/ph-bhp-layout/svg/icon-edit.svg">
            </a>
        </div>
    </div>
    <div class="container-fluid">
        <div class="page-content-2 questionnaire-preview" *ngIf="questionnaire">
            <div class="questionnaire-header">
                <h2 class="background_title">{{ questionnaire.questionnaireName }}</h2>
                <div class="default-label" *ngIf="questionnaire.isDefault">
                    <span>{{ 'CHECK.DEFAULT_QUESTIONNAIRE' | translate }}</span>
                </div>
            </div>

            <br>

            <div class="questionnaire-items">
                <div [ngClass]="item.isCaption ? 'caption' : 'question'" *ngFor="let item of questionnaire.questions">
                    <ng-container *ngIf="item.isCaption">
                        <span>{{ item.statement }}</span>
                    </ng-container>

                    <ng-container *ngIf="!item.isCaption">
                        <div class="statement">
                            <lib-html-text [text]="item.statement"></lib-html-text>
                            <button (click)="onClickQuestionInfo(item)" *ngIf="showInfoButton(item)" class='info-button'
                                type='button'>
                                <img src='assets/icons/infoOutlined.svg' />
                            </button>
                        </div>

                        <div class="description"
                            *ngIf="item.referenceDesc && item.referenceDesc?.length > 0">
                            <p>{{ item.referenceDesc }}</p>
                        </div>

                        <div class="answers">
                            <div [ngClass]="getOptionsDisplay(item)">
                                <ng-container *ngIf="isInputQuestion(item)">
                                    <div class="input-answers w-25 mb-4">
                                        <label class="input-floating">
                                            <input formControlName="answer" *ngIf="isNumericalInput(item)" type="number"
                                                class="form-input numeric-input"
                                                placeholder="{{ 'CHECK.QUESTIONNAIRE.ENTER_NUMBER' | translate }}"
                                                disabled />
                                            <input formControlName="answer" *ngIf="!isNumericalInput(item)" type="text"
                                                class="form-input text-input"
                                                placeholder="{{ 'CHECK.QUESTIONNAIRE.ENTER_TEXT' | translate }}"
                                                disabled />
                                            <span>{{ (isNumericalInput(item) ? 'CHECK.QUESTIONNAIRE.ENTER_NUMBER' :
                                                'CHECK.QUESTIONNAIRE.ENTER_TEXT') | translate }}</span>
                                        </label>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!isInputQuestion(item)">
                                    <ng-container *ngIf="item.questionType?.captionPosition === 'Top'">
                                        <div *ngFor="let answer of item.answers; let j = index"
                                            class="input-radio vertical-caption">
                                            <label class="answer-text">{{ answer.statement | translate }}</label>
                                            <div class="input">
                                                <input type="radio" [ngClass]="getInputSkin(item?.questionType?.skin)">
                                                <label class="vertical-label"
                                                    [ngClass]="getInputLabelSkin(item?.questionType?.skin)">&nbsp;</label>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="item.questionType?.captionPosition === 'Bottom'">
                                        <div *ngFor="let answer of item.answers; let j = index"
                                            class="input-radio vertical-caption">
                                            <div class="input">
                                                <input type="radio" [ngClass]="getInputSkin(item?.questionType?.skin)">
                                                <label class="vertical-label"
                                                    [ngClass]="getInputLabelSkin(item?.questionType?.skin)">&nbsp;</label>
                                            </div>
                                            <label class="answer-text">{{ answer.statement | translate }}</label>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="item.questionType?.captionPosition === 'Right'">
                                        <div *ngFor="let answer of item.answers; let j = index" class="input-radio">
                                            <input type="radio" [ngClass]="getInputSkin(item?.questionType?.skin)">
                                            <label [ngClass]="getInputLabelSkin(item?.questionType?.skin)">{{ answer.statement |
                                                translate }}
                                            </label>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="item.questionType?.captionPosition === 'Left'">
                                        <div *ngFor="let answer of item.answers; let j = index"
                                            class="input-radio left-caption">
                                            <div class="input">
                                                <input type="radio" [ngClass]="getInputSkin(item?.questionType?.skin)">
                                                <label class="left-label"
                                                    [ngClass]="getInputLabelSkin(item?.questionType?.skin)">&nbsp;</label>
                                            </div>
                                            <label class="answer-text">{{ answer.statement | translate }}</label>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="item.questionType?.captionPosition === 'None'">
                                        <div class="answer-box" *ngFor="let answer of item.answers; let j = index">
                                            <div class="input">
                                                <input [ngClass]="getInputSkin(item?.questionType?.skin)" type="radio">
                                                <label [ngClass]="getInputLabelSkin(item?.questionType?.skin)">&nbsp;</label>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <div class="comment">
                            <label class="input-floating">
                                <input type="text" class="form-input comment-input"
                                    placeholder="'CHECK.COMMENT' | translate" disabled />
                                <span>{{ 'CHECK.COMMENT' | translate }}</span>
                            </label>
                        </div>

                        <hr class="separator">
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<lib-inspection-offcanvas [isCollapsed]="isCollapsed" (childData)="onchildData($event)"
    [additionalInfoData]="getAdditionalInfo()"></lib-inspection-offcanvas>